<template>
  <DsDocumentationSection
    tag="Documentación"
    title="Lo que necesitarás para tu proceso"
    title-id="liquidacion-documentation-title"
    description="Reuné esta documentación para que tu proceso avance sin contratiempos."
    :image="documentationDesktopImage"
    :tablet-image="documentationTabletImage"
    :mobile-image="documentationDesktopImage"
    image-alt="Casa a escala sobre planos junto a una lupa"
    :items="documentationItems"
    secondary-title="Recomendaciones importantes"
    :secondary-items="recommendationItems"
    media-last-mobile
    class="liquidacion-documentation"
  />
</template>

<script setup lang="ts">
import documentationDesktopImage from '../../../../../assets/liquidacion/liquidacion-documentation-desktop.webp'
import documentationTabletImage from '../../../../../assets/liquidacion/liquidacion-documentation-tablet.webp'
import contractIcon from '../../../../../assets/liquidacion/liquidacion-contract.svg'
import mortgageIcon from '../../../../../assets/liquidacion/liquidacion-mortgage.svg'
import paymentIcon from '../../../../../assets/liquidacion/liquidacion-payment.svg'
import statementIcon from '../../../../../assets/liquidacion/liquidacion-statement.svg'
import DsDocumentationSection from '../components/DsDocumentationSection.vue'

const documentationItems = [
  {
    id: 'active-contracts',
    iconSrc: contractIcon,
    iconWidth: 24,
    iconHeight: 24,
    text: 'Número de contrato(s) activo(s)'
  },
  {
    id: 'account-statement',
    iconSrc: statementIcon,
    iconWidth: 24,
    iconHeight: 24,
    text: 'Solicitud de estado de cuenta para liquidación total o parcial'
  },
  {
    id: 'mortgage-cancellation',
    iconSrc: mortgageIcon,
    iconWidth: 24,
    iconHeight: 24,
    text:
      'Documentación correspondiente para el trámite de cancelación de ' +
      'hipoteca (en caso de liquidación total)'
  }
]

const recommendationItems = [
  {
    id: 'payment-punctuality',
    iconSrc: paymentIcon,
    iconWidth: 24,
    iconHeight: 24,
    text:
      'Mantén la puntualidad en los pagos de los contratos que continúen ' +
      'vigentes o activos.'
  }
]
</script>

<style scoped>
.liquidacion-documentation :deep(.ds-documentation-section__media) {
  aspect-ratio: 238 / 258;
}

.liquidacion-documentation :deep(.ds-documentation-section__image) {
  object-position: center;
}

@media (min-width: 768px) {
  .liquidacion-documentation :deep(.ds-documentation-section__media) {
    align-self: stretch;
    height: auto;
    aspect-ratio: auto;
  }

  .liquidacion-documentation :deep(.ds-documentation-section__image) {
    position: absolute;
    inset: 0;
  }

  .liquidacion-documentation :deep(.ds-documentation-section__media) {
    position: relative;
  }
}
</style>
